import axios from "../api";

export const listTransactionDataAction = async (perPage, page, searchValue, startDate, endDate, statusFilter, amountFilter, tenantFilter) => {
  let apiUrl = `/api/transaction?page=${page}&pageSize=${perPage}&status=${statusFilter}`;
  if (amountFilter) {
    apiUrl += `&amount=${amountFilter}`;
  }

  if (searchValue !== "all") {
    searchValue = searchValue.trim();
    apiUrl += `&searchValue=${searchValue}`;
  }

  if (startDate && endDate) {
    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
  }

  if (tenantFilter !== "all") {
    apiUrl += `&tenantFilter=${tenantFilter}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRecentTopTransactionsAction = async (searchValue, statusFilter) => {
  let apiUrl = `/api/transaction/fetchRetchTransaction?status=${statusFilter}`;

  if (searchValue !== "all") {
    searchValue = searchValue.trim();
    apiUrl += `&searchValue=${searchValue}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const exportAllTransactionAction = (data, transactionId, merchantId) => {
  return new Promise((resolve, reject) => {
    let url = "/api/transaction/export";
    if (transactionId != null) {
      url += `?id=${transactionId}`;
    }
    if (merchantId != null) {
      url += transactionId != null ? `&merchantId=${merchantId}` : `?merchantId=${merchantId}`;
    }
    axios
      .post(url, data, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const exportTransactionHistoryAction = (data) => {
  return new Promise((resolve, reject) => {
    let url = "/api/transaction/export";
    axios
      .post(url, data, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const exportReportDataAction = (data) => {
  return new Promise((resolve, reject) => {
    let url = "/api/transaction/exportReportData";

    axios
      .post(url, data, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTransactionChartAction = async (startDate, endDate, merchantId) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/transaction-chart`;
    if (startDate && endDate) {
      apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    }
    if (merchantId) {
      apiUrl += `${apiUrl.includes("?") ? "&" : "?"}merchantId=${merchantId}`;
    }
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTransactionTotalAmountAction = async (startDate, endDate, merchantId) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/total-transaction-amount`;
    if (startDate && endDate) {
      apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    }
    if (merchantId) {
      apiUrl += `${apiUrl.includes("?") ? "&" : "?"}merchantId=${merchantId}`;
    }
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTransactionTotalCountAction = async (startDate, endDate, merchantId) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/total-transaction-count`;
    if (startDate && endDate) {
      apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    }
    if (merchantId) {
      apiUrl += `${apiUrl.includes("?") ? "&" : "?"}merchantId=${merchantId}`;
    }
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTransactionHistoryByAmountChartAction = async (startDate, endDate, merchantId) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/amount-chart`;

    if (startDate && endDate) {
      apiUrl += `${apiUrl.includes("?") ? "&" : "?"}startDate=${startDate}&endDate=${endDate}`;
    }
    if (merchantId) {
      apiUrl += `${apiUrl.includes("?") ? "&" : "?"}merchantId=${merchantId}`;
    }
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getTransactionHistoryByStatusChartAction = async (startDate, endDate, merchantId, websiteId) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/status-chart`;

    if (startDate && endDate) {
      apiUrl += `${apiUrl.includes("?") ? "&" : "?"}startDate=${startDate}&endDate=${endDate}`;
    }

    if (merchantId) {
      apiUrl += `${apiUrl.includes("?") ? "&" : "?"}merchantId=${merchantId}`;
    }

    if (websiteId) {
      apiUrl += `${apiUrl.includes("?") ? "&" : "?"}websiteId=${websiteId}`;
    }

    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTransactionHistoryDailyChartAction = ({ startDate, endDate, merchantId } = {}) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/daily-transaction-chart`;
    let hasParams = false;

    if (startDate && endDate) {
      apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
      hasParams = true;
    }

    if (merchantId) {
      apiUrl += `${hasParams ? "&" : "?"}&merchantId=${merchantId}`;
    }
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAllChartsAndCardDetailsAction = (filters = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/transaction/getallchart-card-details`, {
        params: filters,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTransactionsChartDataAction = ({ startDate, endDate, merchant, chartType, websiteId }) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/transactions-chart`;
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (merchant) params.append("merchant", merchant);
    if (chartType) params.append("chartType", chartType);
    if (websiteId) params.append("websiteId", websiteId);
    const queryString = params.toString();
    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCalendarChartDataAction = ({ startDate, endDate, merchant, chartType, websiteId }) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/calendar-chart`;
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (merchant) params.append("merchant", merchant);
    if (chartType) params.append("chartType", chartType);
    if (websiteId) params.append("websiteId", websiteId);
    const queryString = params.toString();
    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRevenueChartDataAction = ({ startDate, endDate, merchant, chartType, websiteId }) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/revenue-chart`;
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (merchant) params.append("merchant", merchant);
    if (chartType) params.append("chartType", chartType);
    if (websiteId) params.append("websiteId", websiteId);
    const queryString = params.toString();
    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getPaymentMethodChartDataAction = ({ startDate, endDate, merchant, chartType, websiteId }) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/transaction/payment-method-chart`;
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (merchant) params.append("merchant", merchant);
    if (chartType) params.append("chartType", chartType);
    if (websiteId) params.append("websiteId", websiteId);
    const queryString = params.toString();
    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRecentTransactionsAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/transaction/getRecentTransactions`)
      .then((response) => {
        resolve(response.data.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTopPerformingMerchantsAction = () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/transaction/getTopPerformingMerchants")
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCardDataAction = ({ cardType, startDate, endDate, merchant, websiteId }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/transaction/getallchart-card-details`, {
        params: {
          startDate,
          endDate,
          merchant,
          cardType,
          websiteId,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(`Error fetching ${cardType} data:`, error);
        reject(error);
      });
  });
};

export const getTransactionSummaryAction = async (filters = {}) => {
  let apiUrl = `/api/transaction/summary?`;
  
  const params = new URLSearchParams();

  if (filters.startDate) {
    params.append('startDate', filters.startDate);
  }

  if (filters.endDate) {
    params.append('endDate', filters.endDate);
  }

  if (filters.status && filters.status !== "all") {
    params.append('status', filters.status);
  }

  if (filters.tenantFilter && filters.tenantFilter !== "all") {
    params.append('tenantFilter', filters.tenantFilter);
  }

  if (filters.searchValue && filters.searchValue !== "all" && filters.searchValue.trim()) {
    params.append('searchValue', filters.searchValue.trim());
  }

  if (filters.amount && filters.amount !== "all") {
    params.append('amount', filters.amount);
  }
  apiUrl += params.toString();
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data?.data || {});
      })
      .catch((error) => {
        reject(error);
      });
  });
};
